(function () {
  function initWhatsappChat(root) {
    if (!root || root.dataset.tcWhatsappReady === 'true') return;
    root.dataset.tcWhatsappReady = 'true';

    function currentProductUrl() {
      if (root.dataset.tcWhatsappPageType !== 'product') {
        return root.dataset.tcWhatsappProductUrl || '';
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('preview_theme_id');
        return url.toString();
      } catch (error) {
        return root.dataset.tcWhatsappProductUrl || window.location.href;
      }
    }

    function buildMessage() {
      if (root.dataset.tcWhatsappPageType === 'product' && root.dataset.tcWhatsappProductTitle) {
        return (root.dataset.tcWhatsappProductMessage || '')
          .replace(/\{product_title\}/g, root.dataset.tcWhatsappProductTitle)
          .replace(/\{product_url\}/g, currentProductUrl());
      }

      return root.dataset.tcWhatsappGenericMessage || '';
    }

    function updateHref() {
      var phone = root.dataset.tcWhatsappPhone || '';
      if (!phone) return;
      root.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(buildMessage());
    }

    updateHref();

    root.addEventListener('click', function () {
      updateHref();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'whatsapp_click',
        event_category: 'WhatsApp',
        event_label: 'Native floating button'
      });

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'click', {
          event_category: 'WhatsApp',
          event_label: 'Native floating button'
        });
      }
    });

    window.addEventListener('popstate', updateHref);
    document.addEventListener('shopify:section:load', updateHref);
  }

  function initAllWhatsappChats() {
    document.querySelectorAll('[data-tc-whatsapp-chat]').forEach(initWhatsappChat);
  }

  initAllWhatsappChats();

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-tc-whatsapp-chat]').forEach(initWhatsappChat);
  });

  if (!window.tcWhatsappChatObserver) {
    window.tcWhatsappChatObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1 || !node.isConnected) return;
          if (node.matches('[data-tc-whatsapp-chat]')) initWhatsappChat(node);
          node.querySelectorAll('[data-tc-whatsapp-chat]').forEach(initWhatsappChat);
        });
      });
    });
    window.tcWhatsappChatObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
